import * as React from 'react';
import { toast } from 'react-toastify';
import GoogleMapDunny from './GoogleMapsDunny';
import { useParams } from "react-router-dom";
import { GetQuery, PostQuery } from './Shared';
import type { ScheduleRoutesDunny, ScheduleRoutesJobAddress } from './models/JobScheduleInterfaces';
import type { GenericList } from './models/JobSharedInterfaces';
import Select, {type MultiValue } from 'react-select'


type OptionsItem = {
    label: string,
    value: number
}

const AllocateMapDunnyData = () => {
    const [pins, setPins] = React.useState<ScheduleRoutesJobAddress[]>([]);
    const [routes, setRoutes] = React.useState<ScheduleRoutesDunny[]>([]);
    const [loading, setLoading] = React.useState(true);
    const [truckOptions, setTruckOptions] = React.useState<OptionsItem[]>([]);
    const [selectedTrucks, setSelectedTrucks] = React.useState<OptionsItem[]>([]);
    const [itemOptions, setItemOptions] = React.useState<OptionsItem[]>([]);
    const [selectedItems, setSelectedItems] = React.useState<OptionsItem[]>([]);
    const [scheduleTypeOptions, setScheduleTypeOptions] = React.useState<GenericList[]>([]);
    const [scheduleTypeId, setScheduleTypeId] = React.useState(-1);
    const [showUnallocated, setShowUnallocated] = React.useState(true);
    const [refreshMap, setRefreshMap] = React.useState(false);
    const { scheduleDate } = useParams<{ scheduleDate: string }>();
    const { scheduleBranchId } = useParams<{ scheduleBranchId: string }>();
    const { itemTypeGroupId } = useParams<{ itemTypeGroupId: string }>();

    React.useEffect(() => {
        getAllocateAddressesDunny();
    }, [scheduleDate, scheduleBranchId, itemTypeGroupId]);
    

    const getAllocateAddressesDunny = async () => {
        const apiUrl = "GetAddressFencingToiletForAllocating?ScheduleDate=" + scheduleDate + '&ScheduleBranchId=' + scheduleBranchId + '&ItemTypeGroupId=' + itemTypeGroupId;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setPins(result.data.jobAddresses);

            //allocated jobs - show route - routes will be blank at this stage
            var newroutes: ScheduleRoutesDunny[] = [];
            setRoutes(newroutes);

            setTruckOptions(result.data.truckOptions);
            setItemOptions(result.data.itemOptions);
            setSelectedItems(result.data.itemOptions);
            setScheduleTypeOptions(result.data.scheduleTypeOptions);
            setLoading(false);
            setRefreshMap(true);
        };
    }

    const getAllocateAddressesDunnyFiltered = async (filterSelectedItems: OptionsItem[], filterSelectedTrucks: OptionsItem[], filterShowUnallocated: boolean, filterScheduleType: number) => {
        

        var filter = {
            scheduleDate: scheduleDate,
            scheduleBranchId: scheduleBranchId ? parseInt(scheduleBranchId) : 1,
            itemTypeGroupId: itemTypeGroupId ? parseInt(itemTypeGroupId) : 1,
            selectedItems: filterSelectedItems,
            selectedTrucks: filterSelectedTrucks,
            showUnallocated: filterShowUnallocated,
            scheduleTypeId: filterScheduleType,
        };

        var jsonItem = JSON.stringify(filter);

        const apiUrl = "GetFilteredAddressesForAllocating";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setPins(result.data.jobAddresses);

            //allocated jobs - show route
            setRoutes(result.data.routes);

            setRefreshMap(!refreshMap);
        };
    }

    const handleMultiItemChange = (selected: MultiValue<OptionsItem>) => {
        var result = [...selected];
        setSelectedItems(result);
        getAllocateAddressesDunnyFiltered(result, selectedTrucks, showUnallocated, scheduleTypeId);
    }

    const handleMultiTruckChange = (selected: MultiValue<OptionsItem>) => {
        var trucks = [...selected];
        setSelectedTrucks(trucks);
        getAllocateAddressesDunnyFiltered(selectedItems, trucks, showUnallocated, scheduleTypeId);
    }

    const handleShowUnallocatedChange = (e: any) => {
        setShowUnallocated(e.target.checked);
        getAllocateAddressesDunnyFiltered(selectedItems, selectedTrucks, e.target.checked, scheduleTypeId);
    }

    const handleScheduleTypeChange = (e: any) => {
        var value = e.target.value * 1;
        setScheduleTypeId(value);
        getAllocateAddressesDunnyFiltered(selectedItems, selectedTrucks, showUnallocated, value);
    }


    const customStyles = {
        control: (baseStyles: any) => ({
            ...baseStyles,
            flex: 1,
            maxWidth: '450px',
            minWidth: '250px'
        })
    };

    let map = <GoogleMapDunny pins={pins} routes={routes} refreshMap={refreshMap} />

    const renderDetails = (
        <div className="makeitflexrow"> 
            <div className="mapfiltersize">
                <h3>Google Map Filter/s</h3>
                <label className="input-group" htmlFor="itemId">
                    <span className="label label-small">Item</span>
                    <Select styles={customStyles} isMulti id="itemFilter" name="itemFilter" defaultValue={selectedItems} options={itemOptions} onChange={handleMultiItemChange} />
                </label> 
                <label className="input-group" htmlFor="truckFilterId">
                    <span className="label label-small">Truck</span>
                    <Select isMulti id="truckFilter" name="truckFilter" defaultValue={selectedTrucks} options={truckOptions} onChange={handleMultiTruckChange} />
                </label>
                <label className={selectedTrucks.length > 0 ? "input-group" : "hidden"} htmlFor="showUnallocated">
                    <span className="label label-small">Show Unallocated</span>
                    <input className="input" type="checkbox" name="showUnallocated" checked={showUnallocated} onChange={(e) => handleShowUnallocatedChange(e)}></input>
                </label>
                <label className="input-group" htmlFor="scheduleTypeId">
                    <span className="label label-small">Schedule Type</span>
                    <select className="" id="scheduleTypeId" name="scheduleTypeId" value={scheduleTypeId} onChange={(e) => handleScheduleTypeChange(e)}>
                        <option defaultValue="-1" value={-1}></option>
                        {scheduleTypeOptions.map(type =>
                            <option key={type.id} value={type.id}>{type.name}</option>
                        )};
                    </select>
                </label>
            </div>
            <div className="mapsize">
                {map}
            </div>

        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );

};

export default AllocateMapDunnyData;